import Post from "../Post";
import getToken from "../token";

export default function detailConsultationUser(consultationId) {
  return Post("counseling/detailCounselingDoctor", {
    token: getToken(),
    counselingId: consultationId,
  });
}
